import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/SystemBanner/sgds-system-banner";
import { register } from "../../utils/ce-registry";

register("sgds-system-banner", Component);

export default createComponent({
  react: React,
  tagName: "sgds-system-banner",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsHide: "sgds-hide"
  }
});
